"use client";

import { type ReactNode } from "react";

import { Dialog, DialogContent, DialogTrigger } from "~/components/ui/dialog";
import { useTrack } from "~/lib/use-track";

export function LearnMore({
  children,
  label,
  type,
}: {
  children: ReactNode;
  label: ReactNode;
  type: "accommodation" | "transfers";
}) {
  const track = useTrack();
  return (
    <Dialog
      onOpenChange={(open) => {
        if (open && type === "accommodation") {
          track({ name: "Open Accommodation Modal" });
        } else if (open && type === "transfers") {
          track({ name: "Open Transfers Modal" });
        }
      }}
    >
      <DialogTrigger asChild>
        <button type="button" className="text-prune-500 font-medium">
          {label}
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-screen overflow-y-scroll">
        {children}
      </DialogContent>
    </Dialog>
  );
}
